import { fetchStocks } from "./inventoryAction";
import { formatData, sortByDateReverse } from "./utils";

export const transferTypes = {
    "achat": "PURCHASES",
    "arrivage": "ARRIVAGES",
    "demande": "DEMANDS",
    "vente": "SALES", // includes payg
    "reapprovisionnement": "REAPPRO",
    "reapprovisionnement_ext": "REAPPRO_EXT",
    "installation": "INSTALLS",
    "reservation_demande": "RESA_DEMANDS",
    "reservation": "RESERVATIONS",
    "commercial": "COMMERCIAL_REAS",
    "commercial_return": "COMMERCIAL_RETURNS",
    "occasion_vente": "RETURN_SALES",
    "occasion_payg": "RETURN_SALES",
    "occasion": "RETURN_SALES",
    "avoir": "AVOIRS",
    "draft": "REA_DRAFTS",
    "quote": "QUOTES",
}

export function fetchTranferTypes(type){ // "achat, reappro ..."
    console.log("FIRED ACTION FETCH ", transferTypes[type] )
    return async function(dispatch){
        dispatch({
            type: `FETCH_${[transferTypes[type]]}_START`,
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 'Content-Type': 'application/json'},
                body:JSON.stringify({
                    page:type,
                }),
                credentials: 'same-origin',
            }); 
            
            const list = await response.json()
            console.log(list)

            if(!list.error){
                dispatch({ type: `GET_${[transferTypes[type]]}`, payload: formatData(sortByDateReverse(list.reverse())) });
                dispatch({ type: `FETCH_${[transferTypes[type]]}_FULFILLED`, payload:"" })
                console.log(type, " fetched")            
            } else {
                dispatch({
                    type: `FETCH_${[transferTypes[type]]}_ERROR`,
                    payload: list.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: `FETCH_${[transferTypes[type]]}_ERROR`,
                payload: err?.message || err?.toString() || 'An error occurred while fetching transfer types'
            })
        }
    }
}

export function fetchSingleStocks(id, page){
    console.log("FIRED ACTION FETCH STOCK History" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SINGLE_STOCKS_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ page, id }),
                credentials: 'same-origin',
            }); 
            const list = await response.json()
            console.log({list})
            console.log('====================================');
            console.log(list.error, !list.error);
            console.log('====================================');
            if(!list.error){ // no errors, return new Object     
                // dispatch({ type: `GET_SINGLE_STOCKS`, payload: {status, list: formatData(list)} });    
                return list
            } else {
                dispatch({
                    type: "FETCH_SINGLE_STOCKS_ERROR",
                    payload: list.error.message
                })
                return {}
            }
        } catch (err) {
            dispatch({
                type: "FETCH_SINGLE_STOCKS_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while fetching single stocks'
            })
        }
    }
}
// export function fetchSingleStocks(id, page, status){
//     console.log("FIRED ACTION FETCH STOCK History" )
//     return async function(dispatch){
//         dispatch({
//             type: "FETCH_SINGLE_STOCKS_START",
//             payload: ""
//         })
//         try {
//             const response = await fetch('/stocks/single',{
//                 method:'POST',
//                 headers: {'Content-Type': 'application/json'},
//                 body: JSON.stringify({ page, id }),
//                 credentials: 'same-origin',
//             }); 
//             const list = await response.json()
//             console.log({list})
//             console.log('====================================');
//             console.log(list.error, !list.error);
//             console.log('====================================');
//             if(!list.error){ // no errors, return new Object     
//                 dispatch({ type: `GET_SINGLE_STOCKS`, payload: {status, list: formatData(list)} });    
//                 return list
//             } else {
//                 dispatch({
//                     type: "FETCH_SINGLE_STOCKS_ERROR",
//                     payload: list.error.message
//                 })
//                 return {}
//             }
//         } catch (err) {
//             dispatch({
//                 type: "FETCH_SINGLE_STOCKS_ERROR",
//                 payload: err
//             })
//         }
//     }
// }
// export function fetchStockHistory(product, shop, status){
export function fetchStockHistory(stockID){
    console.log("FIRED ACTION FETCH STOCK History" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_STOCK_HISTORY_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page:"stock/history",
                    id: stockID
                    // product,
                    // shop,
                    // status
                }),
                credentials: 'same-origin',
            }); 
            const list = await response.json()
            console.log({list})// transfer returns new object created
            console.log('====================================');
            console.log(list.error, !list.error);
            console.log('====================================');
            if(!list.error){ // no errors, return new Object         
                console.log('==============fetchStockHistory======================');
                console.log({list});
                console.log('====================================');    
                const groupedProducts = groupProductsByTransferID(list);
                // const groupedProducts = groupProductsByItemID(list);
                let newList = Object.values(groupedProducts);
                //console.log('==============fetchStockHistory======================');
                //console.log({newList});
                //console.log('====================================');    
                return sortByDateReverse(newList, "creation_date")
            } else {
                dispatch({
                    type: "FETCH_HISTORY_ERROR",
                    payload: list.error.message
                })
                return {}
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_HISTORY_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while fetching stock history'
            })
        }
    }
}

// NOTE: fetchStockMovements a été déplacé vers stockMovementAction.jsx
// pour une meilleure organisation du code Redux
export function fetchTransferDetails(id, page = "transfer"){
    console.log("FIRED ACTION FETCH TRANSFER" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_TRANSFER_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page,
                    id,
                }),
                credentials: 'same-origin',
            }); 
            
            const transfer = await response.json()
            console.log({transfer})// transfer returns new object created

            if(!transfer.error){ // no errors, return new Object         
                const groupedProducts = groupProductsByProductId(transfer.products);
                transfer.products = Object.values(groupedProducts);
                console.log('==============fetchTransferDetails======================');
                console.log({transfer});
                console.log('====================================');    
                return transfer
            }

            dispatch({
                type: "FETCH_TRANSFER_ERROR",
                payload: transfer.error.message
            })
            throw new Error(transfer.error.message);
            
        } catch (err) {
            dispatch({
                type: "FETCH_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while fetching transfer details'
            })
            throw err;
        }
    }
}
export function fetchTransferDetailsTmp(id, page){
    console.log("FIRED ACTION FETCH TRANSFER" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_TRANSFER_START",
            payload: ""
        })
        try {
            
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page,
                    id,
                }),
                credentials: 'same-origin',
            }); 
            
            const transfer = await response.json()
            console.log(transfer)// transfer returns new object created

            if(!transfer.error){ // no errors, return new Object         
                
                console.log('==============fetchTransferDetails======================');
                console.log({transfer});
                console.log('====================================');    
                return transfer
            } else {
                dispatch({
                    type: "FETCH_TRANSFER_ERROR",
                    payload: transfer.error.message
                })
                return {}
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while fetching transfer details'
            })
        }
    }
}
export function singleTransferGet(id, page){
    console.log("FIRED ACTION FETCH TRANSFER" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_TRANSFER_START",
            payload: ""
        })
        try {
            
            const response = await fetch('/stocks/single',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    page,
                    id,
                }),
                credentials: 'same-origin',
            }); 
            
            const transfer = await response.json()
            console.log(transfer)// transfer returns new object created

            if(!transfer.error){ // no errors, return new Object         
                
                console.log('==============singleTransferGet======================');
                console.log({transfer});
                console.log('====================================');    
                dispatch(fetchStocks())
                return transfer
            } else {
                dispatch({
                    type: "FETCH_TRANSFER_ERROR",
                    payload: transfer.error.message
                })
                return {}
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while fetching transfer'
            })
        }
    }
}

export function groupProductsByProductId(products) {
    if (!products || !Array.isArray(products)) {
        return {};
    }
    return products.reduce((acc, product) => {
        const { product_id, ...rest } = product;
        if (!acc[product_id]) {
            // acc[product_id] = product
            // acc[product_id].quantity = rest.quantity || 0;
            // acc[product_id].cost = rest.cost * rest.quantity || 0;
            // acc[product_id].total_ht = rest.price_ht * rest.quantity || 0;
            // acc[product_id].total_ttc = rest.price_ttc  * rest.quantity || 0;

            // acc[product_id].totalCost = rest.cost || 0
            // acc[product_id].price_ttc = rest.price_ttc || 0
            // acc[product_id].price_ht = rest.price_ht || 0
            
            acc[product_id] = { ...product, 
                quantity: product.quantity || 0, 
                rest_to_return: rest.available ? product.quantity : 0, 
                list: [product],
                cost: rest.cost,
                total_ht: rest.price_ht,
                total_ttc: rest.price_ttc
            }
    
        } else {

            acc[product_id].quantity += rest.quantity || 0;
            acc[product_id].cost += rest.cost || 0;
            acc[product_id].total_ht += rest.price_ht || 0;
            acc[product_id].total_ttc += rest.price_ttc  || 0;
            if (rest.available){
                acc[product_id].rest_to_return += rest.quantity
            }
            acc[product_id].list.push(product);

            // console.log('====================================');
            // console.log(rest.quantity, rest.price_ht, rest.price_ttc, rest.price_ttc  * rest.quantity  );
            // console.log({acc});
            // console.log('====================================');
            // // Calcul de la moyenne du price_ht
            // acc[product_id].price_ht =
            //     (acc[product_id].price_ht * (acc[product_id].quantity - rest.quantity) + 
            //     rest.price_ht * rest.quantity) / acc[product_id].quantity;
        
        }

    
        return acc;
    }, {});
}

export function groupProductsByTransferID(products) {
    if (!products || !Array.isArray(products)) {
        return {};
    }
    return products.reduce((acc, product) => {
        const { transfer_id, ...rest } = product;
        if (!acc[transfer_id]) {            
            acc[transfer_id] = { ...product, 
                quantity: product.quantity || 0, 
                rest: rest.available ? product.quantity : 0, 
                list: [product],
                cost: rest.cost,
                total_ht: rest.price_ht,
                total_ttc: rest.price_ttc
            }
    
        } else {

            acc[transfer_id].quantity += rest.quantity || 0;
            acc[transfer_id].cost += rest.cost || 0;
            acc[transfer_id].total_ht += rest.price_ht || 0;
            acc[transfer_id].total_ttc += rest.price_ttc  || 0;
            if (rest.available){
                acc[transfer_id].rest += rest.quantity
            }
            acc[transfer_id].list.push(product);
        }

    
        return acc;
    }, {});
}
export function groupProductsByItemID(products) {
    if (!products || !Array.isArray(products)) {
        return {};
    }
    return products.reduce((acc, product) => {
        const { item_id, ...rest } = product;
        if (!acc[item_id]) {            
            acc[item_id] = { ...product, 
                quantity: product.quantity || 0, 
                rest: rest.available ? product.quantity : 0, 
                list: [product],
                cost: rest.cost,
                total_ht: rest.price_ht,
                total_ttc: rest.price_ttc
            }
    
        } else {

            acc[item_id].quantity += rest.quantity || 0;
            acc[item_id].cost += rest.cost || 0;
            acc[item_id].total_ht += rest.price_ht || 0;
            acc[item_id].total_ttc += rest.price_ttc  || 0;
            if (rest.available){
                acc[item_id].rest += rest.quantity
            }
            acc[item_id].list.push(product);
        }

    
        return acc;
    }, {});
}

export function createTransfer(newTransfer){
    // console.log("FIRED ACTION CREATE TRANSFER", newTransfer)
    return async function(dispatch){
        dispatch({
            type: "CREATE_TRANSFER_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfer",
                    data:newTransfer
                }),
                credentials: 'same-origin',
            }); 
            
            const createdTransfer = await response.json()
            console.log(createdTransfer)// createdTransfer returns new object created

            if(createdTransfer.id){ // no errors, return new Object
                dispatch({
                    type: "NEW_TRANSFER",
                    payload: createdTransfer
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer created")

                // if arrivage, change status
                // received = true
                if (newTransfer.arrivage_id){
                    dispatch({ type: "RECEIVED_ARRIVAGE", payload: newTransfer.arrivage_id })
                }
            } else {
                dispatch({
                    type: "CREATE_TRANSFER_ERROR",
                    payload: createdTransfer.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT TRANSFER ", err);
            dispatch({
                type: "CREATE_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while creating transfer'
                
            })
        }
    }
}
export function updateTransfer(newTransfer){
    // console.log("FIRED ACTION CREATE TRANSFER", newTransfer)
    return async function(dispatch){
        dispatch({
            type: "CREATE_TRANSFER_START",
            payload: ""
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page: "transfers/update",
                    data: newTransfer
                }),
                credentials: 'same-origin',
            }); 
            
            const createdTransfer = await response.json()
            console.log(createdTransfer)// createdTransfer returns new object created

            if(createdTransfer.id){ // no errors, return new Object
                dispatch({
                    type: "DELETE_TRANSFER",
                    payload: newTransfer.id
                    
                })
                dispatch({
                    type: "NEW_TRANSFER",
                    payload: createdTransfer
                    
                })
                dispatch(fetchStocks())
                dispatch({ type: "CREATE_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer created")

                // if arrivage, change status
                // received = true
                if (newTransfer.arrivage_id){
                    dispatch({ type: "RECEIVED_ARRIVAGE", payload: newTransfer.arrivage_id })
                }
            } else {
                dispatch({
                    type: "CREATE_TRANSFER_ERROR",
                    payload: createdTransfer.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT TRANSFER ", err);
            dispatch({
                type: "CREATE_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while updating transfer'
                
            })
        }
    }
}
export function addFilesTransfer(files){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_TRANSFER_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfers/add/files",
                    data:files
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedTransfer = await response.json()
            console.log(updatedTransfer)// updatedTransfer returns new object created

            if(updatedTransfer.success === false){
                dispatch({
                    type: "ADD_FILES_TRANSFER_ERROR",
                    payload: updatedTransfer.message
                })
                return updatedTransfer
            }

            if(updatedTransfer.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_TRANSFER",
                    payload: updatedTransfer

                })
                dispatch({ type: "ADD_FILES_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer updated")
                return updatedTransfer

            } else {
                dispatch({
                    type: "ADD_FILES_TRANSFER_ERROR",
                    payload: updatedTransfer.error.message

                })

            }

        } catch (err) {
            console.log("[ERROR] files TRANSFER ", err);
            dispatch({
                type: "ADD_FILES_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while adding files to transfer'

            })
        }
    }
}
export function deleteFileTransfer({ id, password, filename }){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_TRANSFER_START",
            payload: ""

        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfers/delete/file",
                    data:{ id, password, filename }
                }),
                credentials: 'same-origin',
            });

            const res = await response.json()
            console.log(res)

            if(res.success === false){
                dispatch({
                    type: "ADD_FILES_TRANSFER_ERROR",
                    payload: res.message
                })
                return { error: res.message }
            }

            if(res.id){ // no errors, return updated transfer
                dispatch({
                    type: "UPDATE_TRANSFER",
                    payload: res

                })
                dispatch({ type: "ADD_FILES_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer file deleted")
                return res

            } else {
                const message = res.error?.message || "Erreur lors de la suppression du fichier"
                dispatch({
                    type: "ADD_FILES_TRANSFER_ERROR",
                    payload: message

                })
                return { error: message }
            }

        } catch (err) {
            console.log("[ERROR] delete file TRANSFER ", err);
            const message = err?.message || err?.toString() || 'An error occurred while deleting transfer file'
            dispatch({
                type: "ADD_FILES_TRANSFER_ERROR",
                payload: message

            })
            return { error: message }
        }
    }
}
export function addFacturesTransfer(factures){
    return async function(dispatch){
        dispatch({
            type: "ADD_FILES_TRANSFER_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfers/add/factures",
                    data:factures
                }),
                credentials: 'same-origin',
            }); 
            
            const updatedTransfer = await response.json()
            console.log(updatedTransfer)// updatedTransfer returns new object created

            if(updatedTransfer.id){ // no errors, return new Object
                dispatch({
                    type: "UPDATE_TRANSFER",
                    payload: updatedTransfer
                    
                })
                dispatch({ type: "ADD_FILES_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer updated")

            } else {
                dispatch({
                    type: "ADD_FILES_TRANSFER_ERROR",
                    payload: updatedTransfer.error.message
                    
                })
                
            }
            
        } catch (err) {
            console.log("[ERROR] factures TRANSFER ", err);
            dispatch({
                type: "ADD_FILES_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while adding factures to transfer'
                
            })
        }
    }
}
export function receiveTransfer(transfer){
    console.log("FIRED ACTION RECEIVE TRANSFER", transfer)
    return async function(dispatch){
        dispatch({ type: "RECEIVE_TRANSFER_START", payload: "" })
        try {
            const infos = await fetch('/stocks/changeStatus',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(transfer),
                credentials: 'same-origin',
            });
            let updatedTransfer = await infos.json();
            console.log("[INFO] change status receive transfer ",updatedTransfer);// return true or false
            
            if(updatedTransfer.id){ // no errors, return new Object
                if(updatedTransfer.nature === "reapprovisionnement"){
                    dispatch({ type: "UPDATE_TRANSFER_REAPPRO", payload: updatedTransfer })
                } else {
                    dispatch({ type: "UPDATE_TRANSFER", payload: updatedTransfer })
                }
                dispatch({ type: "RECEIVE_TRANSFER_FULFILLED", payload:"" })
                console.log("Transfer UPDATED ")

                dispatch(fetchStocks())
            } else {
                dispatch({ type: "RECEIVE_TRANSFER_ERROR", payload: updatedTransfer.error.message })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT TRANSFER ", err);
            dispatch({ type: "RECEIVE_TRANSFER_ERROR", payload: err?.message || err?.toString() || 'An error occurred while receiving transfer' })
        }
    }
}

export function deleteTransfer(transfer){
    return async function(dispatch){
        dispatch({ type: "DELETE_TRANSFER_START", payload: "" })
        try {
            const infos = await fetch('/stocks/cancelTransfer',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    transfer
                }),
                credentials: 'same-origin',
            });
            let res = await infos.json();
            console.log("[INFO] delete transfer res ",res);// return true or false
            
            if(res === 'ok'){ // no errors, return new Object
                dispatch({
                    type: "DELETE_TRANSFER",
                    payload: transfer.id
                })
                dispatch({ type: "DELETE_TRANSFER_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                console.log("Transfer deleted")
            } else {
                dispatch({
                    type: "DELETE_TRANSFER_ERROR",
                    payload: res.error.message
                })
            }
            
        } catch (err) {
            console.log("[ERROR] DELETE TRANSFER ", err);
            dispatch({
                type: "DELETE_TRANSFER_ERROR",
                payload: err?.message || err?.toString() || 'An error occurred while deleting transfer'
            })
        }
    }
}

export function linkTransfersTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            const req = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfers/link/to/compta",
                    data:data
                }),
                credentials: 'same-origin',
            }); 
            
            let res = await req.json();
            console.log('linkTransfersTo5000 res : ', res);

            if(!res.error){ // no errors, return new Object 
                try {
                    const req2 = await fetch('/money/link/update/spending', {
                        method: 'POST',
                        body: JSON.stringify({spending_id: data.spending_id, spending_rest_to_match: res }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('linkTransfersTo5000 res2 update spending : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        // data = {
                        //     spending_id : "",
                        //     id_list: []string, OLD 
                        //     id_list: map[transfer_id]amount, 
                        //     total: float64
                        // }
                        dispatch({
                            type: "UPDATE_TRANSFERS_LINK",
                            payload: {list: Object.keys(data.id_list), spending_id: data.spending_id} 
                        })
        
                        dispatch({ type: "LINK_TRANSFERS_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_TRANSFERS_ERROR",
                            payload: res2.error
                        })
                        // cancel saved op
                        await fetch('/stocks/addData',{
                            method:'POST',
                            headers: { 
                                'Content-Type': 'application/json',
                                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                            },
                            body:JSON.stringify({
                                page:"transfers/unlink/to/compta",
                                data:data
                            }),
                            credentials: 'same-origin',
                        }); 
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_TRANSFERS_ERROR",
                        payload: error.message
                    })
                } 
            
            } else {
                dispatch({
                    type: "LINK_TRANSFERS_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_TRANSFERS_ERROR", payload: error.message })
        }     
    }
}
export function unLinkTransfersTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_TRANSFERS_START", payload: "" })
        try {
            const req = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"transfers/unlink/to/compta",
                    data:data
                }),
                credentials: 'same-origin',
            }); 
            
            let res = await req.json();
            console.log('unLinkTransfersTo5000 res : ', res);
            if(!res.error){ // no errors, return new Object
                try {
                    const req2 = await fetch('/money/link/update/spending', {
                        method: 'POST',
                        body: JSON.stringify({spending_id: data.spending_id, spending_rest_to_match: data.total * -1 }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('unLinkTransfersTo5000 res2 update spending : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        dispatch({
                            type: "UPDATE_TRANSFERS_UNLINK",
                            payload: {list: Object.values(data.id_list)} 
                        })
                        dispatch({ type: "LINK_TRANSFERS_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_TRANSFERS_ERROR",
                            payload: res2.error
                        })
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_TRANSFERS_ERROR",
                        payload: error.message
                    })
                }             
            } else {
                dispatch({
                    type: "LINK_TRANSFERS_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_TRANSFERS_ERROR", payload: error.message })
        }
         
    }
}

